import styles from './styles.module.scss'
import Button from '../Button'
import { useState } from 'react'
import { CSSTransition } from 'react-transition-group'
import { withModifiers } from '../../helpers/withModifiers'

const Tabs = ({ content }) => {
  const [activeTab, setActiveTab] = useState(0)

  return (
    <div className={styles.tabs}>
      <div className={styles.tabs__navigation}>
        {content.map((item, index) => (
          <Button
            onClick={() => {
              setActiveTab(index)
            }}
            arrow={false}
            variant={['label']}
            key={`tab-button-${index}`}
            className={withModifiers(
              'tabs__button',
              [index === activeTab && 'current'],
              styles
            )}
          >
            {item.title}
          </Button>
        ))}
      </div>

      <div className={styles.tabs__content}>
        {content.map(
          (item, index) =>
            activeTab === index && (
              <CSSTransition
                classNames="opacity"
                appear={true}
                in={activeTab === index}
                timeout={{ enter: 200, exit: 200 }}
                key={activeTab}
              >
                <div key={`tab-content-${index}`}>{item.content}</div>
              </CSSTransition>
            )
        )}
      </div>
    </div>
  )
}

export default Tabs
